module.exports = __webpack_public_path__ + "img/consult_info2.077151d7.png";